import React, { FunctionComponent, ReactElement, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import withTheme from '@sport1/react-elements/withTheme'
import FilterChip, { FilterChipProps } from '..'
import LabelFont from '../../../Theme/Fonts/Label'
import { TestID } from '../../../utils/PropTypesDefinitions'
import { RequireOnlyOne } from '../../../utils/types/requireOnlyOne'
import { ThemeProps } from '../../../Theme/ThemeComponentTypes'
import ThemeInterface from '../../../themes/ThemeInterface'

export type FilterChipTextProps = RequireOnlyOne<
    Pick<FilterChipProps, 'alt' | 'active' | 'onPress' | 'imageUrl' | 'iconProps' | 'opacity'>,
    'imageUrl' | 'iconProps'
> & {
    /** text which is displayed under the image of this Component */
    text: string
} & ThemeProps &
    TestID

const getTintColor = (
    active: boolean,
    themeName: ThemeInterface['themeName'] = 'light'
): 'white' | 'black' => {
    if (active) {
        return themeName === 'light' ? 'white' : 'black'
    }
    return themeName === 'light' ? 'black' : 'white'
}

const FilterChipText: FunctionComponent<FilterChipTextProps> = ({
    imageUrl,
    alt,
    active = false,
    onPress,
    testID,
    text,
    iconProps,
    theme,
}): ReactElement => {
    return (
        <Grid noExpand center height={62} testID={testID}>
            {iconProps ? (
                <FilterChip
                    type="BACKGROUND"
                    onPress={onPress}
                    active={active}
                    activeBackgroundColor="onyx"
                    iconProps={iconProps}
                />
            ) : (
                <FilterChip
                    type="BACKGROUND"
                    onPress={onPress}
                    active={active}
                    alt={alt}
                    imageUrl={imageUrl}
                    tintColor={getTintColor(active, theme?.themeName)}
                    activeBackgroundColor="onyx"
                    imageSize={28}
                />
            )}
            <LabelFont color={active ? 'onyx' : 'keshi-3'}>{text}</LabelFont>
        </Grid>
    )
}

export default memo(withTheme(FilterChipText))
